module.exports = __webpack_public_path__ + "assets/img/The-Onset-Website.ba56daec.webp";